import { useState } from "react";
import { CheckSquare, ChevronDown, ChevronUp } from "lucide-react";
import { useTranslate } from "ra-core";
import { useIsMobile } from "@/hooks/use-mobile";
import { Button } from "@/components/ui/button";

import { AddTask } from "../tasks/AddTask";
import { TasksListContent } from "../tasks/TasksListContent";
import { ScrollableCard } from "./ScrollableCard";

export const TasksList = ({
  collapsible = false,
}: {
  collapsible?: boolean;
}) => {
  const translate = useTranslate();
  const isMobile = useIsMobile();
  const [expanded, setExpanded] = useState(true);

  const showChevron = collapsible && isMobile;

  return (
    <div className="flex flex-col md:h-full">
      <div className="flex items-center gap-2 min-h-6 pb-3 flex-none">
        <CheckSquare
          className="text-nd-text-disabled w-4 h-4"
          strokeWidth={1.5}
        />
        <span className="font-nd-mono text-[11px] tracking-[0.08em] uppercase text-nd-text-secondary flex-1">
          {translate("crm.dashboard.upcoming_tasks", {
            _: "Upcoming Tasks",
          })}
        </span>
        {!isMobile && <AddTask display="icon" selectContact />}
        {showChevron && (
          <Button
            variant="ghost"
            size="icon"
            className="h-6 w-6 p-0 text-nd-text-disabled hover:text-nd-text-secondary"
            onClick={() => setExpanded((v) => !v)}
          >
            {expanded ? (
              <ChevronUp className="w-3.5 h-3.5" strokeWidth={1.5} />
            ) : (
              <ChevronDown className="w-3.5 h-3.5" strokeWidth={1.5} />
            )}
          </Button>
        )}
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateRows: !collapsible || expanded ? "1fr" : "0fr",
          transition: collapsible
            ? "grid-template-rows 0.3s ease-out"
            : undefined,
          overflow: "hidden",
        }}
      >
        <div style={{ minHeight: 0, overflow: "hidden" }}>
          <ScrollableCard className="p-4">
            <TasksListContent />
          </ScrollableCard>
        </div>
      </div>
    </div>
  );
};
